import { request } from "../../../services/api"
import type { BaseApiResponse } from "../../../types/api.ts"
import type {
  ProjectSubcontractorsParams,
  ProjectSubcontractorsResponse
} from "./services.types.ts"

const BASE_URL = `/project-management/project-subcontractors`

const PATHS = {
  getSubcontractors: `${BASE_URL}/`
}

export const getProjectSubcontractors = async (
  params: ProjectSubcontractorsParams
) => {
  return request.api.get<
    ProjectSubcontractorsResponse,
    BaseApiResponse<unknown>
  >(PATHS.getSubcontractors, params)
}
